import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";

export default function Detail_LoadingBar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);
  const hitRange = item.scale.ranges.find((scale) => scale.isHit);

  return (
    <Row className="justify-content-center mx-0 mb-3">
      <Row className={"justify-content-center"}>
        <Col xs={"auto"} className="detail-section-scope-name-header-wrap-up-old align-content-center">
          {item.name}
        </Col>
        <Col xs={"auto"}>
          <div className="detail-main-scope-score-header-wrap-up">{elementScore}</div>
        </Col>
      </Row>

      <div className="detail-scope-container-wrap-up">
        <div
          style={{
            paddingTop: "12px",
          }}
        >
          <ProgressBar
            variant={isSub ? "sub-scope" : "main-scope"}
            now={elementScore}
            label={`%${elementScore} ${hitRange.text}`}
            style={{ height: "20px" }}
          />
        </div>
        <Row>
          <Col xs="5">
            <div className="detail-scale-text-wrap-up" dangerouslySetInnerHTML={{ __html: item.lowSideText }} />
          </Col>
          <Col xs={{ offset: 2, span: 5 }}>
            <div className="detail-scale-text-wrap-up" dangerouslySetInnerHTML={{ __html: item.highSideText }} />
          </Col>
        </Row>
        {item.generalInformationText?.length > 2 && (
          <div
            className="detail-scale-general-info-text-wrap-up"
            dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
          />
        )}
      </div>
    </Row>
  );
}
